import { MainPage } from './pages/main';
import React from 'react';
import { render as reactRender } from 'react-dom';
import { AppContext } from './context/appContext';
import { ICommonHeaderData } from './interface/base';
import { contextService } from './base/contextService';
import LangCache from './base/langCache';
import { nav } from '@umu/simple-header';
import { LANG_ENUM } from '@umu/umu-lang-switch';
import { getRuntimeLangData } from '@umu/ukit-lang-npm';
import './styles/common.scss';
import { DropDown } from './common/components/dropDown/dropDown';
import { $window } from './common/utils/bom';
import { LoginState } from './components/loginState/loginState';
import { LoginCard } from './components/loginCard/loginCard';
import { EFontSize } from './interface/fontSize';
function APP(props: ICommonHeaderData) {
    return (
        <AppContext.Provider
            value={{
                state: { ...props },
            }}
        >
            <MainPage></MainPage>
        </AppContext.Provider>
    );
}
export const headerDropDown = async (props: ICommonHeaderData) => {
    const runtimeLangData = await getRuntimeLangData('npm/common-header');
    LangCache.setLang(runtimeLangData);
    contextService.lang = props.lang || 'en-us';
    contextService.siteHost = props.siteHost || $window.location.hostname;
    contextService.system = props.system || 'CN';
    return reactRender(
        <AppContext.Provider
            value={{
                state: { ...props },
            }}
        >
            <DropDown content={<LoginState />}>
                <LoginCard />
            </DropDown>
        </AppContext.Provider>,
        props.hostEl || document.querySelector('body'),
    );
};
function renderSimpleHeader(data: ICommonHeaderData) {
    return nav({
        platform: 'twww',
        lang: data.lang || LANG_ENUM['en-us'],
        system: data.system || 'cn',
    });
}

function isLogin(data: ICommonHeaderData) {
    if (!data || !data.userInfo) {
        return false;
    }
    if (data.userInfo.umu_id || data.userInfo.user_id) {
        return true;
    }
    return false;
}

export async function render(
    data: ICommonHeaderData = {} as ICommonHeaderData,
    headerResultCallback?: (type: string, data: any) => void,
) {
    const runtimeLangData = await getRuntimeLangData('npm/common-header');
    LangCache.setLang(runtimeLangData);
    contextService.lang = data.lang || 'en-us';
    contextService.siteHost = data.siteHost || $window.location.hostname;
    contextService.system = data.system || 'CN';

    if (isLogin(data)) {
        reactRender(
            <APP {...data} resultCallback={headerResultCallback}></APP>,
            data.hostEl || document.querySelector('body'),
        );
    } else {
        if (data.hostEl) {
            data.hostEl.innerHTML = '';
        }
        renderSimpleHeader(data);
    }
}

if (process.env.IS_DEV_SERVER) {
    render({
        hostEl: document.getElementById('common-header'),
        isCAdministrator: true,
        siteHost: 'dev42.umucdn.cn',
        system: 'CN',
        lang: LANG_ENUM['zh-cn'],
        fontSize: EFontSize.SMALL,
        siblingSubHeader: true,
        userInfo: {
            uid: '',
            umu_id: '40717',
            student_id: '45032',
            teacher_id: '41056',
            user_name: 'vb',
            avatar: '',
            person_home_url:
                'http://m.daoyu.umucdn.cn/profile/0364040f8d2ee814b4780961',
            achievement_url:
                'http://m.daoyu.umucdn.cn/profile/achievement?uid=0364040f8d2ee814b4780961',
            phone: '13130006011',
            email: '',
            remark: '',
            login_name: '',
            phone_number: '',
            user_level: 8,
            user_growth_points: 357,
            show_user_level: 1,
            user_medal: {
                id: '543',
                medal_type: '102',
                medal_rank: '1',
            },
        },
        enterpriseInfo: {
            role_type: '4',
            enterprise_id: '45',
            enterprise_name: 'demo企业',
            logo_pc:
                'https://statics-umu-cn.umucdn.cn/resource/r/b/zDOzo/3662577563.png',
        },
    });
}
